import {Dialog, DialogActions, DialogContent, DialogTitle, Grid, Button, Paper, Typography} from "@material-ui/core";
import {
    AutocompleteInput,
    BooleanInput,
    NumberInput,
    ReferenceInput,
    SimpleForm,
    TextInput,
} from "react-admin";
import {useNotify, useRedirect} from "react-admin";
import {FormProps} from "../../shared/types";
import {initInput} from "../../shared/utils";
import {useState} from "react";
import {client} from "../../dataProvider";
import {NoteConfigurationUploader, RoiItem} from "./NoteConfigurationUploader";

export const NoteConfigurationForm = (props: FormProps) => {
    const [items, setItems] = useState<RoiItem[]>([]);
    const [settingsOpen, setSettingsOpen] = useState(false);
    const notify = useNotify();
    const redirect = useRedirect();

    const saveConfiguration = async (values: any) => {
        if (!items.length || items.some((item) => !item.bbox || !item.size)) {
            notify("Carica almeno un file e seleziona la ROI su ogni pagina", "warning");
            return;
        }
        try {
            await client("note-configurations/save-configuration", {
                method: "POST",
                data: {
                    cliente: values.client,
                    configurazione: values.configuration,
                    items,
                    replace: values.replace,
                    replace_to: values.replace_to,
                    remove_space: values.remove_space,
                    qr_mode: values.qr_mode,
                    cut_note: values.cut_note,
                    skip_even_pages: values.skip_even_pages,
                    skip_odd_pages: values.skip_odd_pages,
                    read_every_n_pages: values.read_every_n_pages,
                    delete_skipped_pages: values.delete_skipped_pages,
                    rotate: values.rotate_image,
                    final: values.final,
                    charWhitelist: values.char_whitelist,
                    preprocessing: {
                        rescale: values.preprocess_rescale,
                        binarize: values.preprocess_binarize,
                        denoise: values.preprocess_denoise,
                        morphology: values.preprocess_morphology,
                        deskew: values.preprocess_deskew,
                    },
                },
            });
            notify("Configurazione salvata", "info");
            redirect("list", props.basePath);
        } catch (error) {
            notify("Impossibile salvare la configurazione", "warning");
        }
    };

    return (
    <SimpleForm
        {...props}
        save={saveConfiguration}
    >
        <div style={{width: "100%", boxSizing: "border-box"}}>
            <Typography variant="h6" gutterBottom>
                Nuova configurazione bolla
            </Typography>
            <Grid container spacing={2} style={{width: "100%", margin: 0}}>
            <Grid item xs={12} md={6}>
                <ReferenceInput
                    {...initInput("client", props.fieldOptions, props.canEdit)}
                    reference="autocomplete/subject"
                    filter={{type: "client"}}
                    label="Cliente"
                >
                    <AutocompleteInput optionText="label"/>
                </ReferenceInput>
            </Grid>
            <Grid item xs={12} md={6}>
                <TextInput {...initInput("configuration", props.fieldOptions, props.canEdit)} />
            </Grid>
            </Grid>
            <NoteConfigurationUploader onChange={setItems} onOpenSettings={() => setSettingsOpen(true)}
                                       fieldOptions={props.fieldOptions} canEdit={props.canEdit}/>
            <Dialog open={settingsOpen} onClose={() => setSettingsOpen(false)} fullWidth maxWidth="md" keepMounted>
                <DialogTitle>Impostazioni configurazione</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}><TextInput {...initInput("replace", props.fieldOptions, props.canEdit)} /></Grid>
                        <Grid item xs={12} md={4}><TextInput {...initInput("replace_to", props.fieldOptions, props.canEdit)} /></Grid>
                        <Grid item xs={12} md={4}><NumberInput {...initInput("rotate_image", props.fieldOptions, props.canEdit)} defaultValue={0}/></Grid>
                        <Grid item xs={12}><TextInput {...initInput("char_whitelist", props.fieldOptions, props.canEdit)} defaultValue="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-./"/></Grid>
                        <Grid item xs={12}><Paper variant="outlined" style={{padding: 16, backgroundColor: "#f8fbff"}}><Typography variant="subtitle1" gutterBottom>Selezione pagine PDF</Typography><Typography variant="caption" color="textSecondary">Le pagine saltate restano disponibili per la pulizia manuale, salvo eliminazione automatica.</Typography><Grid container spacing={1}>
                            {[['cut_note', 'Taglia a metà la bolla'], ['skip_even_pages', 'Salta pagine pari PDF'], ['skip_odd_pages', 'Salta pagine dispari PDF']].map(([source, label]) => <Grid item xs={12} sm={6} md={4} key={source}><BooleanInput {...initInput(source, props.fieldOptions, props.canEdit)} label={label}/></Grid>)}
                            <Grid item xs={12} sm={6} md={4}><NumberInput {...initInput("read_every_n_pages", props.fieldOptions, props.canEdit)} label="Leggi ogni X pagine PDF" min={1} defaultValue={1} helperText="Prima pagina, poi una ogni X."/></Grid>
                            <Grid item xs={12} sm={6} md={4}><BooleanInput {...initInput("delete_skipped_pages", props.fieldOptions, props.canEdit)} label="Elimina automaticamente le pagine saltate"/></Grid>
                        </Grid></Paper></Grid>
                        <Grid item xs={12} md={6}><Paper variant="outlined" style={{padding: 16, height: "100%"}}><Typography variant="subtitle1" gutterBottom>Riconoscimento</Typography><Grid container>
                            {[['qr_mode', 'Trova QR'], ['remove_space', 'Rimuovi spazi']].map(([source, label]) => <Grid item xs={12} sm={6} key={source}><BooleanInput {...initInput(source, props.fieldOptions, props.canEdit)} label={label}/></Grid>)}
                        </Grid></Paper></Grid>
                        <Grid item xs={12} md={6}><Paper variant="outlined" style={{padding: 16, height: "100%"}}><Typography variant="subtitle1" gutterBottom>Pre-elaborazione immagine</Typography><Grid container>
                            {[['preprocess_rescale', 'Ingrandisci'], ['preprocess_binarize', 'Binarizza'], ['preprocess_denoise', 'Riduci rumore'], ['preprocess_morphology', 'Rinforza caratteri'], ['preprocess_deskew', 'Raddrizza immagine']].map(([source, label]) => <Grid item xs={12} sm={6} key={source}><BooleanInput {...initInput(source, props.fieldOptions, props.canEdit)} label={label} defaultValue={source === "preprocess_rescale"}/></Grid>)}
                        </Grid></Paper></Grid>
                        <Grid item xs={12}><Paper variant="outlined" style={{padding: "8px 16px"}}><BooleanInput {...initInput("final", props.fieldOptions, props.canEdit)} label="Finale"/></Paper></Grid>
                    </Grid>
                </DialogContent>
                <DialogActions><Button color="primary" onClick={() => setSettingsOpen(false)}>Chiudi</Button></DialogActions>
            </Dialog>
        </div>
    </SimpleForm>
    );
};
